/* SANGO — smooth intentional internal navigation to page top */
(function () {
  const NAV_FLAG = 'sangoMenuNavTopV3';
  const OLD_FLAG = 'sangoIntentionalNavTop';
  const OLD_V2_FLAG = 'sangoIntentionalNavTopV2';
  const SCROLL_STORAGE_PREFIX = 'sango-scroll-position:';
  const LEGACY_SCROLL_STORAGE_PREFIX = 'sango-scroll:';

  const safeRemove = (key) => {
    try {
      sessionStorage.removeItem(key);
    } catch (error) {}
  };

  const safeGet = (key) => {
    try {
      return sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  };

  const safeSet = (key, value) => {
    try {
      sessionStorage.setItem(key, value);
    } catch (error) {}
  };

  const clearSavedDestination = (url) => {
    if (!url) return;
    const pagePath = url.pathname + url.search;
    safeRemove(SCROLL_STORAGE_PREFIX + pagePath);
    safeRemove(LEGACY_SCROLL_STORAGE_PREFIX + pagePath);
  };

  // This runs synchronously in <head>, before the page is painted.
  // Clear the flags used by the older fixes so their delayed scroll handlers
  // cannot fire on the destination page.
  const intentionalNavigation =
    safeGet(NAV_FLAG) === '1' ||
    safeGet(OLD_FLAG) === '1' ||
    safeGet(OLD_V2_FLAG) === '1';

  safeRemove(NAV_FLAG);
  safeRemove(OLD_FLAG);
  safeRemove(OLD_V2_FLAG);

  if (intentionalNavigation) {
    try {
      history.scrollRestoration = 'manual';
    } catch (error) {}

    // One immediate reset only. No animation, timers, RAF loop, or delayed snap.
    window.scrollTo(0, 0);

    window.addEventListener(
      'pageshow',
      function () {
        requestAnimationFrame(function () {
          try {
            history.scrollRestoration = 'auto';
          } catch (error) {}
        });
      },
      { once: true }
    );
  }

  const isInternalStoreLink = (anchor) => {
    if (!anchor || !anchor.href) return false;
    if (anchor.target === '_blank' || anchor.hasAttribute('download')) return false;
    if (anchor.closest('header-search')) return false;
    if (anchor.classList.contains('header__button--search')) return false;

    try {
      return new URL(anchor.href, window.location.href).origin === window.location.origin;
    } catch (error) {
      return false;
    }
  };

  document.addEventListener(
    'click',
    function (event) {
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const anchor = event.target.closest('a[href]');

      if (!isInternalStoreLink(anchor)) return;

      const destination = new URL(anchor.href, window.location.href);
      const current = new URL(window.location.href);
      const samePage =
        destination.pathname === current.pathname &&
        destination.search === current.search;

      // Preserve deliberate in-page anchor links.
      if (samePage && destination.hash && destination.hash !== '#top') return;

      // This is the key fix: global.js stores a scroll position for every URL.
      // A deliberate normal link click should ignore that stored destination position.
      clearSavedDestination(destination);

      // Clicking a link for the page already being viewed: one instant
      // top reset, no reload.
      if (samePage) {
        event.preventDefault();
        safeRemove(NAV_FLAG);
        safeRemove(OLD_FLAG);
        safeRemove(OLD_V2_FLAG);
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        return;
      }

      // Tell the destination page this was an intentional internal navigation,
      // and turn off native restoration before the browser starts navigating.
      safeSet(NAV_FLAG, '1');
      try {
        history.scrollRestoration = 'manual';
      } catch (error) {}
    },
    true
  );
})();
